import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JSONRpc } from '../service-jsonrpc';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DocumentService {
    cacheListStatusDossier: any[];
    cacheListStateDossier: any[];
    cacheListZoneDossier: any[];

    constructor(
        private http: HttpClient
    ) {}

    callPOSTJSONRpc(url, rpcMethod): Observable<any> {
        return this.http.post<JSONRpc>(url + '?' + rpcMethod.method, rpcMethod);
    }

    getDocumentsFromDossier(dossierId): Observable<any> {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method:"webservice.document:getDocumentsFromDossier",
            params: {
                dossierId: dossierId
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    updateDocumentsFromDossier(dossierId, documents): Observable<any> {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method:"webservice.document:updateDocumentsFromDossier",
            params: {
                dossierId: dossierId,
                documents: documents
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }

    removeDocumentFromDossier(dossierId, documentId): Observable<any> {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method:"webservice.document:removeDocumentFromDossier",
            params: {
                dossierId: dossierId,
                documentId: documentId
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }
}